import { makeStyles,  } from '@material-ui/core'
import React, { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import {useSelector} from "react-redux";
import {RootState} from "~/store";
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import { MeetingIcon } from "~/components/icons/meeting";
import { DailyPassIcon } from "~/components/icons/dailypass";

const BASE_ACTIONS = [
  { icon: <MeetingIcon />, name: 'Meeting room', url: '/bookings/meeting' },
  /* { icon: <EventIcon />, name: 'Event room', url: '/bookings/event'}, */
]

const useStyles = makeStyles((theme) => ({
	icon: {
        marginBottom: '0.5rem',
        '.MuiSpeedDialIcon-root':{
            marginBottom: '0.5rem',
        }
    },
    speedDial: {
        position: 'fixed',
        '&.MuiSpeedDial-directionUp': {
          bottom: theme.spacing(12),
          right: theme.spacing(1),
        },
    },
	speedDialIcons: {
		//width: '56px',
		//height: '56px',
		'& .MuiSvgIcon-root': {
			width: '56px',
			height: '56px',
		}
	}
}))


const BookingsFab: React.FC = () =>  {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false);
  const [actions , setActions] = React.useState(BASE_ACTIONS)
  const navigate = useNavigate()


  const profileInfo = useSelector( (state: RootState) => { return state?.user?.user;  } );
    const canBookFlexi = useCallback (() => {
      return (profileInfo && profileInfo.TariffNames !== null &&profileInfo.TariffNames.search("Flexi") > -1)
    },[profileInfo])

    const handleClose = (): void => {
        setOpen(false);
      }

      const handleOpen = (): void => {
        setOpen(true);
      }

      const navigateTo = (url: string): void => {
        navigate(url)
      }

      useEffect(() => {
        if (canBookFlexi()){
          const newActions = [...BASE_ACTIONS, { icon: <DailyPassIcon />, name: 'Flexi desk', url: '/bookings/dailypass' }];
          setActions(newActions);
        }
      }, [canBookFlexi])
    return (
        <>
        <SpeedDial
                    ariaLabel="Bookings"
                    icon={< SpeedDialIcon className={classes.icon}/>}
                    className={classes.speedDial}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={open}
                    direction='up'
                    >
                    {actions.map((action) => (
                        <SpeedDialAction
						className={classes.speedDialIcons}
                        onClick={() => navigateTo(action.url)}
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        />
                    ))}
                    </SpeedDial>
        </>
    )
}


export default BookingsFab
